import * as CryptoJS from 'crypto-js';

export class LocalService {
  static key: string = '?A,ca6R8GH*Q-G+eas#3wZ?a"wxMth9T]gTkszu\\A%k,n!AB';

  public static saveData(key: string, value: string) {
    localStorage.setItem(key, this.encrypt(value));
  }

  public static getData(key: string) {
    if (localStorage.getItem(key)) {
      const data = this.decrypt(localStorage.getItem(key));
      if (data) {
        return JSON.parse(data);
      }
    }
    return '';
  }

  public static removeData(key: string) {
    localStorage.removeItem(key);
  }

  public static clearData() {
    localStorage.clear();
  }

  public static encrypt(txt: string): string {
    return CryptoJS.AES.encrypt(txt, this.key).toString();
  }

  public static decrypt(txtToDecrypt: string) {
    return CryptoJS.AES.decrypt(txtToDecrypt, this.key).toString(CryptoJS.enc.Utf8);
  }
}
